// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2paXs","title":"Header_title__3GGSP","side":"Header_side__2vSKv"};